import { POST } from '@/api'
import { toHourClock } from '@/utils/date'

export default {
  namespaced: true,
  state: {
    details: [],
    busy: false,
    ended: false,
  },
  mutations: {
    set(state, value) {
      state.details = value
    },
    busy(state, value) {
      state.busy = value
    },
    ended(state, ended) {
      state.ended = ended
    },
    clear(state) {
      state.details = []
      state.ended = false
    },
  },
  actions: {
    async get({ commit, state }, condition) {
      if (state.ended) return false
      commit('busy', true)

      const { status, message, data } = await POST('/api/web/v2/reservation/history', {
        ...condition,
        status: condition.status || null,
        inputBy: condition.inputBy || null,
        start: state.details.length,
        limit: condition.rsvId ? null : 20,
        rsvId: condition.rsvId || null,
      })

      if (status === 200) {
        if (data.reservations) {
          const historyData = data.reservations.map(history => ({
            ...history,
            reserveDatetime: toHourClock(history.reserveDatetime),
          }))

          commit('set', condition.rsvId ? historyData : state.details.concat(historyData))
        }
        if (!data.pagenation?.next) commit('ended', true)
      } else {
        commit('ended', true)
        commit('app/error', { status, message }, { root: true })
      }

      commit('busy', false)
      return status === 200
    },
  },
}
